"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneyActionCloseConversation = void 0;
const base_1 = require("./base");
const enums_1 = require("../../enums");
const constants_1 = require("../constants");
const utils_1 = require("../utils");
const misc_1 = require("../../misc");
exports.JourneyActionCloseConversation = (0, base_1.journeyAction)({
    action: enums_1.JourneyActionEnum.CloseConversation,
    channels: (0, misc_1.EnumValues)(enums_1.ChannelEnum),
    settings_schema: (0, base_1.settingsValidationSchema)({
        disposition: {
            type: 'string',
            optional: true,
            allow: [null,],
            default: null,
        },
        disposition_note: {
            type: 'string',
            optional: true,
            allow: [null,],
            default: null,
        },
    }),
    getPorts: (node) => {
        return Object.assign(Object.assign({}, base_1.journeyDefaultInputPort), { [constants_1.JOURNEY_ACTION_CLOSE_CONVERSATION_OUTPUT]: (0, utils_1.journeyNodePortAddDefault)({
                id: constants_1.JOURNEY_ACTION_CLOSE_CONVERSATION_OUTPUT,
                type: enums_1.JourneyPortDirectionEnum.Output,
                removable: false,
                required: false,
                index: 0,
                title: 'CLOSED',
                color: null,
            }) });
    },
});
